module.exports = __webpack_public_path__ + "img/24.f762dfa5.svg";